import { Box } from '@mui/material';
import type { RouteComponentProps } from '@reach/router';
import { navigate } from 'gatsby';
import React from 'react';
import { withErrorBoundary } from 'react-error-boundary';
import { defineMessages, useIntl } from 'react-intl';

import { ErrorBoundaryFallback } from '@components/ErrorBoundaryFallback';
import RoundedButton from '@components/RoundedButton';
import ShareCollectionButton from '@components/ShareButton/ShareCollectionButton';

import * as ROUTES from '@constants/routes';

import { useGetMedicationStatements } from '@hooks/api/medication';

import { ShareType } from 'generated/types';

import MedicationList from './MedicationList';

const messages = defineMessages({
  exportPdf: {
    id: 'medicationsMain.exportPdf',
    defaultMessage: 'Export PDF',
  },
});

const Medications: React.FC<RouteComponentProps> = () => {
  const { formatMessage } = useIntl();
  const { data, loading } = useGetMedicationStatements();

  const handleExportPdf = () => {
    void navigate(ROUTES.MEDICATIONS_PRINT);
  };

  return (
    <>
      <Box
        sx={{
          alignItems: 'center',
          display: 'flex',
          gap: 1,
          justifyContent: 'flex-end',
        }}
      >
        <RoundedButton autoSize onClick={handleExportPdf} variant="blue">
          {formatMessage(messages.exportPdf)}
        </RoundedButton>
        <ShareCollectionButton share_type={ShareType.Medications} />
      </Box>
      <MedicationList loading={loading} medications={data} />
    </>
  );
};

export default withErrorBoundary(Medications, {
  FallbackComponent: ErrorBoundaryFallback,
});
